/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable block-scoped-var */
/* eslint-disable eqeqeq */
/* eslint-disable no-sequences */
/* eslint-disable no-loop-func */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable func-names */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
// @ts-nocheck

export const initTawkTo = (
	chatTawkToPropertyId: string,
	chatTawkToWidgetId: string,
): void => {
	var Tawk_API = Tawk_API || {};
	const Tawk_LoadStart = new Date();
	(function () {
		const s1 = document.createElement('script');
		const s0 = document.getElementsByTagName('script')[0];
		s1.async = true;
		s1.src = `https://embed.tawk.to/${chatTawkToWidgetId}/${chatTawkToPropertyId}`;
		s1.charset = 'UTF-8';
		s1.setAttribute('crossorigin', '*');
		s0.parentNode.insertBefore(s1, s0);
	})();
};
